let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4QMLW")).then(() => parcelRequire('1e9Mm'));